import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import {
  createStaffInfoValidationForm,
  editStaffInfoValidationForm,
} from "../../utils/validationSchemas";
import StaffForm from "./StaffForm";
import UserProfile from "./UserProfile";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import TabPanel from "../Reusable/Tab";

const EditStaffInfo = (props: any) => {
  const {
    profile,
    handleEdit,
    isLoading,
    setOpenUserFormPopup,
    openUserFormPopup,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
  } = useForm({
    resolver: yupResolver(editStaffInfoValidationForm),
    defaultValues: {
      ...profile,
    },
  });

  return (
    <>
      <UserProfile profile={profile} />
      <TabPanel
        tabTitle={["Allowed Locations", "Allowed Devices", "Allowed Biometric"]}
        tabPanels={[
          <>
            <FormLayout
              handleSubmit={handleSubmit}
              handleFormSubmit={handleEdit}
              setError={setError}
              buttonLabel={"Update"}
              isLoading={isLoading}
            >
              <StaffForm
                register={register}
                errors={errors}
                setValue={setValue}
                getValues={getValues}
                clearErrors={clearErrors}
                control={control}
                watch={watch}
                isEdit={false}
                profile={profile}
                setOpenUserFormPopup={setOpenUserFormPopup}
                openUserFormPopup={openUserFormPopup}
              />
            </FormLayout>
          </>,
        ]}
      />
    </>
  );
};

export default EditStaffInfo;
